/* Brain2Canvas — animiertes Wellen-Mesh (Canvas). Dezent, langsam, performant.
   Einsetzen: <canvas class="meshbg"></canvas> + <script src="meshbg.js"></script>.
   Optionen am Element: data-color (Linienfarbe), data-opacity,
                        data-cutter (K10, DEAKTIVIERT — siehe unten).

   K10 — Bolzenschneider (Owner-Idee, Owner-Wunsch 31.07.2026: weglassen):
   Das gelbe Werkzeug (Bolzenschneider-Cursor) inkl. Aufreiß-Effekt ist
   HART DEAKTIVIERT (CUTTER_ENABLED = false, siehe unten). Der Code bleibt
   im Repo als dokumentierte, deaktivierte Option — kein Mount des
   .b2c-cutter-Elements, keine Cutter-Zeichnung, keine Riss-Berechnung.
   Das Mesh-Warp (Grundschwingung + sanftes Ausweichen um den Mauszeiger)
   bleibt vollständig aktiv. Nur pointer:fine ab 960px, nie bei
   prefers-reduced-motion, nie auf Touch.
   ========================================================================= */
(function () {
  // Owner-Wunsch 31.07.2026: Bolzenschneider (gelbes Werkzeug + Riss-Effekt) weg.
  // Mesh-Warp (Grundschwingung + Mauszeiger-Ausweichen) bleibt aktiv.
  var CUTTER_ENABLED = false;

  var CUT_MAX = 14;          // gleichzeitig lebende Schnitte
  var CUT_LIFE = 1400;       // ms bis ein Schnitt ausgefedert ist
  var CUT_R = 132;           // Wirkradius eines Schnitts
  var CUT_AMP = 34;          // maximale Aufreißweite in px
  var CUT_EVERY = 46;        // ms Mindestabstand zwischen zwei Schnitten

  var cuts = [];             // {x,y,nx,ny,t0}
  var lastCut = 0;

  /* ---------------------------------------------------- Cursor-Grafik ---- */
  function mountCutter() {
    var el = document.createElement('div');
    el.className = 'b2c-cutter';
    el.setAttribute('aria-hidden', 'true');
    el.innerHTML =
      '<svg viewBox="0 0 64 64" fill="none">' +
        // dunkler Unterzug, damit das Werkzeug auf jedem Untergrund steht
        '<g stroke="#0b0b0d" stroke-width="7" stroke-linecap="round" stroke-linejoin="round" opacity=".7">' +
          '<path d="M52 20 L61 12"/><path d="M52 44 L61 52"/>' +
          '<path class="jaw jaw--a" d="M52 20 L34 32 L14 26"/>' +
          '<path class="jaw jaw--b" d="M52 44 L34 32 L14 38"/>' +
        '</g>' +
        '<g stroke="#fbeca0" stroke-width="3.8" stroke-linecap="round" stroke-linejoin="round">' +
          // Griffe
          '<path d="M52 20 L61 12"/><path d="M52 44 L61 52"/>' +
          // Gelenk
          '<circle cx="34" cy="32" r="3.4" fill="#0b0b0d"/>' +
          // Backen (klappen beim Schneiden zu)
          '<path class="jaw jaw--a" d="M52 20 L34 32 L14 26"/>' +
          '<path class="jaw jaw--b" d="M52 44 L34 32 L14 38"/>' +
        '</g>' +
      '</svg>';
    document.body.appendChild(el);
    return el;
  }

  /* -------------------------------------------------------- Mesh ---------- */
  function init(cv) {
    var ctx = cv.getContext('2d');
    var color = cv.getAttribute('data-color') || 'rgba(157,161,202,.55)';
    var op = parseFloat(cv.getAttribute('data-opacity') || '1');
    var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    var GAP = 34;
    var w, h, cols, rows, t = 0, raf;
    var interactive = matchMedia('(min-width:960px) and (pointer:fine)').matches && !reduce;
    var mx = -9999, my = -9999, R = 150, PUSH = 26;

    function resize() {
      var r = cv.getBoundingClientRect();
      var dpr = Math.min(devicePixelRatio || 1, 2);
      w = r.width; h = r.height;
      cv.width = w * dpr; cv.height = h * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      cols = Math.ceil(w / GAP) + 2;
      rows = Math.ceil(h / GAP) + 2;
    }

    // gedämpfte Schwingung: reißt sofort auf, federt dann aus
    function spring(age) {
      if (age >= CUT_LIFE) return 0;
      var u = age / CUT_LIFE;
      return Math.exp(-4.2 * u) * Math.cos(u * Math.PI * 3.1);
    }

    function warp(x, y, time, now) {
      var dx = Math.sin(y * 0.012 + time * 0.6) * 16
             + Math.sin((x * 0.6 + y) * 0.006 + time * 0.4) * 12;
      var dy = Math.cos(x * 0.012 + time * 0.5) * 16
             + Math.cos((y * 0.6 + x) * 0.006 + time * 0.45) * 12;

      if (interactive) {
        var ddx = x - mx, ddy = y - my, d2 = ddx * ddx + ddy * ddy;
        if (d2 < R * R) {
          var d = Math.sqrt(d2) || 1, f = (1 - d / R), push = f * f * PUSH;
          dx += (ddx / d) * push; dy += (ddy / d) * push;
        }
        if (CUTTER_ENABLED) {
          for (var k = 0; k < cuts.length; k++) {
            var c = cuts[k];
            var ex = x - c.x, ey = y - c.y;
            var dist2 = ex * ex + ey * ey;
            if (dist2 > CUT_R * CUT_R) continue;
            var dist = Math.sqrt(dist2);
            var fall = 1 - dist / CUT_R;
            // Seite der Schnittlinie: Vorzeichen der Projektion auf die Normale
            var side = ex * c.nx + ey * c.ny;
            var s = side < 0 ? -1 : 1;
            var amp = CUT_AMP * fall * fall * spring(now - c.t0) * s;
            dx += c.nx * amp;
            dy += c.ny * amp;
          }
        }
      }
      return [x + dx, y + dy];
    }

    function draw() {
      var now = performance.now();
      if (cuts.length) {
        cuts = cuts.filter(function (c) { return now - c.t0 < CUT_LIFE; });
      }
      ctx.clearRect(0, 0, w, h);
      ctx.lineWidth = 1;
      ctx.strokeStyle = color;
      ctx.globalAlpha = op;
      var x, y, p, i, j;
      for (j = 0; j < rows; j++) {
        ctx.beginPath();
        for (i = 0; i < cols; i++) {
          x = i * GAP - GAP; y = j * GAP - GAP;
          p = warp(x, y, t, now);
          i === 0 ? ctx.moveTo(p[0], p[1]) : ctx.lineTo(p[0], p[1]);
        }
        ctx.stroke();
      }
      for (i = 0; i < cols; i++) {
        ctx.beginPath();
        for (j = 0; j < rows; j++) {
          x = i * GAP - GAP; y = j * GAP - GAP;
          p = warp(x, y, t, now);
          j === 0 ? ctx.moveTo(p[0], p[1]) : ctx.lineTo(p[0], p[1]);
        }
        ctx.stroke();
      }
      ctx.globalAlpha = 1;
    }

    function loop() { t += 0.006; draw(); raf = requestAnimationFrame(loop); }

    resize(); draw();
    addEventListener('resize', function () { resize(); if (reduce) draw(); });

    // CUTTER_ENABLED=false (Owner-Wunsch 31.07.2026): wantCutter ist immer
    // false, das .b2c-cutter-Element wird nie gemountet, keine Riss-Zeichnung.
    // Das data-cutter-Attribut auf dem Canvas wird bewusst ignoriert.
    var wantCutter = CUTTER_ENABLED && interactive && cv.hasAttribute('data-cutter');
    var cutterEl = null, hideTimer = 0, prevX = 0, prevY = 0, havePrev = false;

    if (interactive) {
      addEventListener('pointermove', function (ev) {
        if (ev.pointerType && ev.pointerType !== 'mouse') return;
        var r = cv.getBoundingClientRect();
        // Mesh-Warp bleibt aktiv: mx/my treiben weiterhin den sanften
        // Ausweich-Effekt (R/PUSH) in warp() an, unabhängig vom Cutter.
        mx = ev.clientX - r.left; my = ev.clientY - r.top;

        if (!wantCutter) return;
        if (!cutterEl) {
          cutterEl = mountCutter();
        }
        // Über Bedienelementen zaehlt der System-Cursor, nicht die Deko.
        var onControl = !!(ev.target && ev.target.closest && ev.target.closest('a,button,input,label,[role=group]'));
        var inside = ev.clientY >= r.top && ev.clientY <= r.bottom && !onControl;
        document.documentElement.classList.toggle('cutting', inside);
        cutterEl.classList.toggle('on', inside);
        cutterEl.style.transform = 'translate3d(' + ev.clientX + 'px,' + ev.clientY + 'px,0)';

        if (!inside) { havePrev = false; return; }

        var vx = ev.clientX - prevX, vy = ev.clientY - prevY;
        var speed = havePrev ? Math.hypot(vx, vy) : 0;
        prevX = ev.clientX; prevY = ev.clientY; havePrev = true;

        var now = performance.now();
        if (speed > 6 && now - lastCut > CUT_EVERY) {
          lastCut = now;
          var len = Math.hypot(vx, vy) || 1;
          // Normale zur Bewegungsrichtung: entlang ihr klafft der Riss auf
          cuts.push({ x: mx, y: my, nx: -vy / len, ny: vx / len, t0: now });
          if (cuts.length > CUT_MAX) cuts.shift();
          cutterEl.classList.add('bite');
          clearTimeout(hideTimer);
          hideTimer = setTimeout(function () { cutterEl.classList.remove('bite'); }, 110);
        }
      }, { passive: true });

      addEventListener('pointerdown', function () {
        if (cutterEl) cutterEl.classList.add('bite');
      }, { passive: true });
    }

    if (!reduce) loop();
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (reduce) return;
          if (e.isIntersecting) { if (!raf) loop(); }
          else {
            cancelAnimationFrame(raf); raf = null;
            if (cutterEl) cutterEl.classList.remove('on');
          }
        });
      }, { threshold: 0 }).observe(cv);
    }
  }

  function boot() { document.querySelectorAll('canvas.meshbg').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
